import React, { useState } from "react";
import {
  addRental,
  addWallet,
  getRentHistory,
  userWallet,
} from "../../utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Table,
  Typography,
  message,
} from "antd";

const Wallet = ({
  row,

  albums,
  musics,
}) => {
  const [visible, setVisible] = useState(false);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["user-wallet-history", row._id, visible],
    queryFn: async () => await userWallet(row._id),
    enabled: visible,
  });
  console.log(musics);

  return (
    <div>
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        Wallet History
      </Button>
      <Drawer
        title={"Wallet History"}
        confirmLoading={isLoading}
        open={visible}
        onClose={() => setVisible(false)}
        footer={null}
        width={800}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}
          >
            Wallet
          </Typography>
          <AddData
            refech={refetch}
            albums={albums}
            musics={musics}
            update={row}
          />
        </div>
        <Table
          dataSource={data?.walletHistory?.history}
          columns={[
            {
              title: "Title",
              dataIndex: ["title"],
            },
            {
              title: "Balance",
              dataIndex: ["balance"],
            },

            {
              title: "Date",
              dataIndex: ["date"],
            },
            {
              title: "Transaction From",
              dataIndex: ["transactionFrom"],
            },
          ]}
        />
      </Drawer>
    </div>
  );
};

export default Wallet;

const AddData = ({
  refech,

  update,
  albums,
  musics,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) => await addWallet(update?._id, values),
    {
      onSuccess: () => {
        message.success(`Added`);
        //reset form
        form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        message.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button
        type="primary"
        onClick={() => setVisible(true)}
        style={{
          width: "100%",
        }}
      >
        Add
      </Button>
      <Modal
        title={"Add Wallet"}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 9 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          onFinish={(values) => {
            mutate(values);
          }}
        >
          {" "}
          <Form.Item
            label="Music Sharing"
            name="musicSharing"
            required
            rules={[
              {
                required: true,
                message: "Please select name!",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="App Sharing"
            name="appSharing"
            required
            rules={[
              {
                required: true,
                message: "Please select!",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="Content"
            name="content"
            required
            rules={[
              {
                required: true,
                message: "Please select!",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="Withdrawable"
            name="withdrawable"
            required
            rules={[
              {
                required: true,
                message: "Please select!",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="Message"
            name="message"
            required
            rules={[
              {
                required: true,
                message: "Please select!",
              },
            ]}
          >
            <Input.TextArea />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
